function isWeekend(date) {
  var weekendDays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0, 6];
  return weekendDays.includes(date.getDay());
}

export { isWeekend };